import { Reveal, Eyebrow } from "./Motion";

const PILLARS = [
  { k: "01", t: "Excellence", d: "We strive to excel in everything we do." },
  { k: "02", t: "Ease", d: "We make HR simpler to navigate and effortless to manage." },
  { k: "03", t: "Experience", d: "We create meaningful experiences for everyone we work with." },
];

export const Pillars = ({ eyebrow = "Philosophy", title = "Excellence. Ease. Experience.", sub = "The three principles behind everything we do.", items = PILLARS }) => (
  <section className="relative overflow-hidden bg-[#074E48] text-white grain" data-testid="pillars-section">
    <div className="relative mx-auto max-w-[1400px] px-6 py-24 lg:px-12 lg:py-36">
      <Reveal>
        <Eyebrow light>{eyebrow}</Eyebrow>
        <h2 className="font-display mt-6 max-w-4xl text-3xl font-bold tracking-tight sm:text-5xl lg:text-6xl" data-testid="pillars-title">{title}</h2>
        <p className="mt-6 max-w-3xl text-base leading-relaxed text-[#CFE7E3] md:text-lg">{sub}</p>
      </Reveal>
      <div className="mt-20 grid gap-px bg-white/10 md:grid-cols-3">
        {items.map((p, i) => (
          <Reveal key={p.k} delay={i * 0.1} className="bg-[#074E48]">
            <div className="group h-full p-8 transition-colors duration-500 hover:bg-[#063A36] lg:p-12" data-testid={`pillar-${i}`}>
              <span className="font-display text-sm font-semibold tracking-[0.3em] text-[#D4AF37]">{p.k}</span>
              <h3 className="font-display mt-10 text-3xl font-bold uppercase tracking-[0.08em] lg:text-4xl">{p.t}</h3>
              <p className="mt-4 text-sm leading-relaxed text-[#CFE7E3] md:text-base">{p.d}</p>
              <span className="mt-8 block h-px w-10 bg-[#D4AF37] transition-[width] duration-500 group-hover:w-24" />
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
